/**
 * Интервалы опроса API: длиннее = меньше RPS и нагрузка на бэкенд/Graylog.
 * Вкладка в фоне (document.hidden) не опрашивается — см. вызовы в Dashboard / SupportChatList.
 */
export const SUPPORT_UNREAD_POLL_INTERVAL_MS = 45_000;
export const ADMIN_SUPPORT_CHAT_LIST_POLL_INTERVAL_MS = 90_000;
export const BILLING_UNREAD_POLL_INTERVAL_MS = 180_000;
